import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify, {});

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        //New Colors
        primary: '#000000',
        secondary: '#6969FF',
        neutral: '#EFECEC',
        neutralVarient: 'CCCCCC',
        success: '#6DF481',
        error: '#FF5F5F',
        accent: '#B4B4FF',
        gray: '#41424c',
        graph1: '#6FB6FF',
        graph2: '#A8F8B3',
        graph3: '#FFAFAF',
        opposite: '#FFFFFF',

        //old Stuff - avoid using
        terciary: '#C8C2FC',
        tertiary: '#C8C2FC',
        background: colors.grey.lighten4,
        title: '#1E1E1E',
        alt1: '#f39b36',
        icon: colors.white,
        green: '#ADF792',
        yellow: '#FFED1A',
        white: '#FFFFFF',
        blue: '#2986FF',
        purple: '#8E54CC',
        brown: '#9C6636',
        black: '#000000',
        gold: '#fbc42e',
        silver: '#B8B8B8',
        bronze: '#ce8740',
        orange: '#fd9927',

        // admin+ colors
        plusPrimary: '#3F51B5',
        plusSecondary: '#536DFE',
        plusTextOnSecondary: '#FFFFFF',
        plusAccent: '#5C6BC0',
        plusError: '#C60000',
        plusSuccess: '#26A69A',
        plusWarning: '#FF9800',
        plusInfo: '#536DFE',
        plusBackground: '#FAFAFA',
        plusSurface: '#FFFFFF',
        plusTextPrimary: '#383838',
        plusTextSecondary: '#616161',
        plusSubtitle: '#757575',
        plusBorder: '#E0E0E0',
        plusGreyLighten1: '#BDBDBD',
        plusGreyLighten4: '#C5C5C5',
        plusGreyLighten2: '#E0E0E0',
        plusGreyLighten3: '#EEE',
        plusGreyLighten5: '#FAFAFA',
        plusGreyDarken1: '#757575',
        plusGreyDarken2: '#616161',
        plusGreyDarken3: '#383838',
        plusGreyDarken4: '#212121',
        plusGreenAccent4: '#00C853',
        plusGreenDarken4: '#1B5E20',
        plusIndigoIndigo: '#3F51B5',
        plusIndigoLighten1: '#5C6BC0',
        plusIndigoLighten2: '#7986CB',
        plusNavActiveText: '#283593',
        plusIndigoLighten3: '#9FA8DA',
        plusIndigoLighten4: '#C5CAE9',
        plusIndigoLighten5: '#E8EAF6',
        plusIndigoDarken1: '#3949AB',
        plusIndigoDarken2: '#303F9F',
        plusIndigoDarken3: '#283593',
        plusIndigoDarken4: '#1A237E',
        plusIndigoAccent2: '#536DFE',
        plusTealLighten1: '#26A69A',
        plusTealLighten4: '#B2DFDB',
        plusTealLighten5: '#E0F2F1',
        plusTealDarken4: '#004D40',
        plusBlueDarken1: '#1E88E5',
        plusBlueDarken4: '#0D47A1',
        plusBlueLighten5: '#E3F2FD',
        plusDeepPurpleLighten5: '#EDE7F6',
        plusGrey40: '#F5F5F5',
        plusLightGreenLighten5: '#F1F8E9',
        plusDeepOrangeAccent2: '#FF6E40',
        plusDeepOrangeAccent4: '#DD2C00',
        plusDeepOrangeLighten5: '#FBE9E7',
        plusOrangeDarken2: '#F57C00',
        plusAmberDarken4: '#FF6F00',
        plusAmberLighten5: '#FFF8E1',
        plusYellowDarken4: '#F57F17',
        plusPurpleLighten5: '#F3E5F5',
        plusPurpleDarken3: '#6A1B9A',
        plusGreen: '#4CAF50',
        plusGreenAccent3: '#00E676',
        plusGreenLighten5: '#E8F5E9',
        plusRedDarken2: '#D32F2F',
        plusRedDarken4: '#B71C1C',
      },
      dark: {
        //New Colors
        primary: '#FFFFFF',
        secondary: '#4444FF',
        neutral: '#808080',
        neutralVarient: 'E60000',
        success: '#12E02F',
        error: '#FF5F5F',
        accent: '#f36284',
        gray: '#EFECEC',
        graph1: '#6FB6FF',
        graph2: '#6DF481',
        graph3: '#fd9927',
        opposite: '#000000',

        //old Stuff - avoid using
        terciary: '#C8C2FC',
        tertiary: '#C8C2FC',
        background: colors.grey.darken3,
        title: '#FFFFFF',
        alt1: '#f39b36',
        green: '#ADF792',
        yellow: '#FFED1A',
        white: '#FFFFFF',
        blue: '#2986FF',
        purple: '#8E54CC',
        brown: '#9C6636',
        black: '#000000',
        gold: '#fbc42e',
        silver: '#B8B8B8',
        bronze: '#ce8740',
        orange: '#fd9927',

        // admin+ colors
        plusPrimary: '#5C6BC0',
        plusSecondary: '#7986CB',
        plusTextOnSecondary: '#FFFFFF',
        plusAccent: '#536DFE',
        plusError: '#FF5F5F',
        plusSuccess: '#26A69A',
        plusWarning: '#FFB74D',
        plusInfo: '#536DFE',
        plusBackground: '#121212',
        plusSurface: '#1E1E1E',
        plusTextPrimary: '#FFFFFF',
        plusTextSecondary: '#B0B0B0',
        plusSubtitle: '#BDBDBD',
        plusTealLighten1: '#26A69A',
        plusTealLighten5: '#E0F2F1',
        plusTealDarken4: '#004D40',
        plusBorder: '#383838',
        plusIndigoIndigo: '#5C6BC0',
        plusIndigoLighten1: '#5C6BC0',
        plusIndigoDarken1: '#3949AB',
        plusNavActiveText: '#FFFFFF',
        plusIndigoDarken2: '#303F9F',
        plusIndigoDarken3: '#283593',
        plusGreyDarken2: '#616161',
        plusGreyDarken4: '#FFFFFF',
        plusGreyDarken3: '#383838',
        plusIndigoLighten5: '#E8EAF6',
        plusGreenAccent4: '#00C853',
        plusGreenLighten5: '#E8F5E9',
        plusGreen: '#4CAF50',
        plusGreyDarken1: '#757575',
        plusGreyLighten4: '#F5F5F5',
        plusLightGreenLighten5: '#F1F8E9',
        plusBlueLighten5: '#E3F2FD',
        plusAmberLighten5: '#FFF8E1',
        plusOrangeDarken2: '#F57C00',
        plusDeepOrangeAccent2: '#FF6E40',
        plusAmberDarken4: '#FF6F00',
        plusDeepOrangeLighten5: '#FBE9E7',
        plusDeepOrangeAccent4: '#DD2C00',
        plusPurpleLighten5: '#F3E5F5',
        plusPurpleDarken3: '#6A1B9A',
        plusYellowDarken4: '#F57F17',
        plusGrey40: '#F5F5F5',
        plusBlueDarken4: '#0D47A1',
        plusGreenDarken4: '#1B5E20',
        plusIndigoLighten3: '#9FA8DA',
        plusGreenAccent3: '#00E676',
        plusRedDarken2: '#D32F2F',
        plusRedDarken4: '#B71C1C',
      },
    },
  },
});
